<div class="card padding-card t-align-l no-radius border">
    <div class="card-body">
        <h5 class="card-title mb-4">Project Highlights</h5>
        <p class="mb-4 text-muted">Select multiple amenities to highlight your project features</p>
        
        <!-- Amenities Icons Grid -->
        <div class="amenities-grid mb-5">
            <div *ngFor="let amenity of amenitiesList" 
                 class="amenity-item" 
                 [ngClass]="{'selected': amenity.isSelected}"
                 (click)="toggleAmenity(amenity)"
                 [title]="amenity.description">
                <div class="amenity-icon">
                    <i [ngClass]="amenity.icon"></i>
                </div>
                <div class="amenity-name">{{ amenity.name }}</div>
            </div>
        </div>

        <!-- Selected Highlights Preview -->
        <div *ngIf="selectedHighlights.length > 0" class="selected-highlights">
            <h6 class="mb-3">Selected Highlights:</h6>
            <div class="row">
                <div class="col-md-12" *ngFor="let highlight of selectedHighlights">
                    <div class="highlight-card mb-3 p-3 border rounded">
                        <div class="d-flex align-items-start">
                            <div class="highlight-icon mr-3">
                                <i [ngClass]="getAmenityIcon(highlight.amenityId)"></i>
                            </div>
                            <div class="flex-grow-1">
                                <h6 class="mb-2">{{ highlight.amenityName }}</h6>
                                <p class="mb-0 text-justify">{{ highlight.content }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div *ngIf="selectedHighlights.length === 0" class="alert alert-info" role="alert">
            <i class="ri-information-line"></i> Please select at least one amenity to continue.
        </div>
    </div>

    <div>
        <button type="button" 
                (click)="submit()" 
                class="btn btn-primary btn-lg mb-2 float-right mr-2"
                [disabled]="selectedHighlights.length === 0">Next</button>
        <button type="button" (click)="back()" class="btn btn-primary btn-lg mb-2 float-right mr-2">Back</button>
    </div>

</div>